import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}\n\n\n\n\n\n",{ moduleName: "seshy/templates/authenticated/projects/show/project-versions.hbs" })